import {createAsyncThunk, createReducer} from '@reduxjs/toolkit'
import {
  purgeUserData,
  resetPoolsFeeData,
  updatePoolV3ChartData,
  updatePoolV3Data,
  updateProtocolV3ChartData,
  updateProtocolV3Data,
  updateUserDataLoaded,
} from './actions'
import {mapTokenSymbols} from './queries/helpers'
import {AppState} from '..'
import {isEmpty, size} from 'lodash'
import {API_URL} from "~/config";
import {BinChartEntry, ConcentratedLiquidityPoolState, PoolsV3UserData, PoolV3Data} from "~/state/clpools/types";
import {getPoolFeesData, LBPairDayData} from "~/state/clpools/queries/poolFeesData";
import {GRAPHQL_ENDPOINTS} from "~/config/constants/endpoints";
import map from "lodash/map";
import merge from "lodash/merge";

interface PoolUserData {
  poolAddress: string,
  userData?: PoolsV3UserData
}

interface PoolUserChartData {
  poolAddress?: string,
  lastFetched?: number,
  chartData?: BinChartEntry[]
}

const initialState: ConcentratedLiquidityPoolState = {
  data: {},
  userDataLoaded: false,
  protocol: {
    overview: undefined,
    chartData: undefined,
    transactions: undefined,
  },
  pools: {byAddress: {}},
  poolFees: {
    dataLoaded: false,
    byDate: {},
    pools: []
  },
  tokens: {byAddress: {}},
}

interface PoolDatas {
  error: boolean
  data?: {
    [address: string]: PoolV3Data
  }
}

export interface PoolDetails {
  chain: string,
  lbPairAddress: string,
  lbPairName: string,
}

export interface PoolFeeData {
  lbPairAddress: string,
  lbPairName: string,
  feeUSD: string,
  feeTokenXUSD: string,
  feeTokenYUSD: string,
}

export interface PoolFeeDataContainer {
  error: boolean
  data?: {
    [time: number]: PoolFeeData[]
  }
  pools?: PoolDetails[]
}

interface UserPositions {
  [address: string]: {
    data?: PoolV3Data
    userData?: PoolsV3UserData
  }
}

export const fetchAllPoolFeesAsync = createAsyncThunk<PoolFeeDataContainer, { start: number, end: number, chainId: number }>(
  "clpools/fetchAllPoolFeesPerChainAsync",
  async ({chainId, start, end}) => {
    let poolFeesResult: Map<string, LBPairDayData[]> = new Map()

    // for (const chainId of Object.keys(GRAPHQL_ENDPOINTS)) {
    //   const endpoint = GRAPHQL_ENDPOINTS[chainId]
    //   await getPoolFeesData(endpoint.metropolisV21InfoUrl).then(result => {
    //     poolFeesResult[chainId] = result
    //   })
    // }
    const endpoint = GRAPHQL_ENDPOINTS[chainId]
    await getPoolFeesData(endpoint.metropolisV21InfoUrl, start, end, 1000, 0).then(result => {
      poolFeesResult[chainId] = result
    })
    await getPoolFeesData(endpoint.metropolisV21InfoUrl, start, end, 1000, 1000).then(result => {
      poolFeesResult[chainId] = poolFeesResult[chainId].concat(result)
    })
    await getPoolFeesData(endpoint.metropolisV21InfoUrl, start, end, 1000, 2000).then(result => {
      poolFeesResult[chainId] = poolFeesResult[chainId].concat(result)
    })
    await getPoolFeesData(endpoint.metropolisV21InfoUrl, start, end, 1000, 3000).then(result => {
      poolFeesResult[chainId] = poolFeesResult[chainId].concat(result)
    })
    await getPoolFeesData(endpoint.metropolisV21InfoUrl, start, end, 1000, 4000).then(result => {
      poolFeesResult[chainId] = poolFeesResult[chainId].concat(result)
    })
    // await getPoolFeesData(endpoint.metropolisV21InfoUrl, 1000, 5000).then(result => {
    //   poolFeesResult[chainId] = poolFeesResult[chainId].concat(result)
    // })
    // await getPoolFeesData(endpoint.metropolisV21InfoUrl, 1000, 6000).then(result => {
    //   poolFeesResult[chainId] = poolFeesResult[chainId].concat(result)
    // })

    const pools: Map<string, PoolDetails> = new Map()
    const poolFeeDataContainer: PoolFeeDataContainer = {error: false, data: []}
    const poolFeeData = {}
    if (poolFeesResult) {
      // @ts-ignore
      map(poolFeesResult, (data: LBPairDayData[], chainId: string) => {
        map(data, (lbpairDayData: LBPairDayData) => {
          const existingEntry = poolFeeData[lbpairDayData.date]
          pools.set(lbpairDayData.lbPair.id, {
            chain: chainId,
            lbPairAddress: lbpairDayData.lbPair.id,
            lbPairName: lbpairDayData.lbPair.name,
          })
          if (existingEntry) {
            const updatedEntry = [
              ...existingEntry,
              {
                lbPairAddress: lbpairDayData.lbPair.id,
                lbPairName: lbpairDayData.lbPair.name,
                feeUSD: lbpairDayData.feesUSD,
                // feeTokenXUSD: new BigNumber(lbpairDayData.lbPair.feesTokenX).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenXPriceUSD)).toFixed(),
                // feeTokenYUSD: new BigNumber(lbpairDayData.lbPair.feesTokenY).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenYPriceUSD)).toFixed(),
              }
            ]
            poolFeeData[lbpairDayData.date] = updatedEntry
          } else {
            poolFeeData[lbpairDayData.date] = [{
              lbPairAddress: lbpairDayData?.lbPair?.id,
              lbPairName: lbpairDayData?.lbPair?.name,
              feeUSD: lbpairDayData?.feesUSD,
              // feeTokenXUSD: new BigNumber(lbpairDayData.lbPair.feesTokenX).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenXPriceUSD)).toFixed(),
              // feeTokenYUSD: new BigNumber(lbpairDayData.lbPair.feesTokenY).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenYPriceUSD)).toFixed(),
            }]
          }
        })
      })
      poolFeeDataContainer.data = poolFeeData
      poolFeeDataContainer.pools = Array.from(pools.values())
      return poolFeeDataContainer
    } else {
      return {error: false} as PoolFeeDataContainer
    }
  })

export const fetchPoolsPublicDataAsync = createAsyncThunk<PoolDatas, { chainId: number, poolAddresses?: string[] }>(
  "clpools/fetchPoolsPublicDataAsync",
  async ({chainId, poolAddresses}) => {

    const pairFilter = poolAddresses ? `pairAddresses=${poolAddresses.join(',')}` : ''
    //   const poolsApiUrl = `${API_URL}/pools?chainId=${chainId}${pairFilter}`
    const poolsApiUrl = `${API_URL}/pools?${pairFilter}`

    console.log("fetchPoolsPublicDataAsync", poolsApiUrl)
    const result = await fetch(poolsApiUrl)
    if (result.ok) {
      const pools = await result.json()

      if (poolAddresses && poolAddresses.length === 1 && pools?.length === 0) {
        // throw new Error(`Pair(s) ${poolAddresses} not found`)
        return {
          [poolAddresses[0]]: {
            exists: false
          }
        } as any
      }

      const poolDatas: PoolDatas = pools.reduce((accum, current) => {
        return {
          ...accum,
          [current.address]: mapTokenSymbols(current)
        }
      }, {})

      return poolDatas
    }
    return {} as PoolDatas
  })


export const fetchPoolUserDataAsync = createAsyncThunk<PoolUserData, { chainId: number, account: string, poolAddress: string }>(
  "clpools/fetchPoolsUserDataAsync",
  async ({chainId, account, poolAddress}) => {

    if (!account) return {} as PoolUserData

    const apiUrl = `${API_URL}/user-positions/${account}?chainId=${chainId}&pairAddresses=${poolAddress}`
    const result = await fetch(apiUrl)
    if (result.ok) {
      const [userData] = await result.json()
      return {
        poolAddress,
        userData
      }
    }

    return {} as PoolUserData
  })

export const fetchUserPositionsAsync = createAsyncThunk<UserPositions, { account: string }>(
  "clpools/fetchUserPositionsAsync",
  async ({account}, {getState}) => {
    const state = getState() as AppState
    const apiUrl = `${API_URL}/user-positions/${account}`
    const result = await fetch(apiUrl)
    if (result.ok) {
      const positions = await result.json()

      let pools = []

      const unfetchedPairAddresses = positions
        .filter((pos) => !state.clPools?.pools?.byAddress[pos.pairAddress])
        .map((pos) => pos.pairAddress)

      if (unfetchedPairAddresses?.length > 0) {
        const poolsApiUrl = `${API_URL}/pools?pairAddresses=${unfetchedPairAddresses.join(',')}`
        const poolsResult = await fetch(poolsApiUrl)
        if (!poolsResult.ok) return {}

        const tmpPools = await poolsResult.json()
        pools = tmpPools.map((current) => mapTokenSymbols(current))
      }

      const userPositions = positions.reduce((accum, current) => {
        return {
          ...accum,
          [current.pairAddress]: {
            userData: current,
            data: pools.find((p) => p.address == current.pairAddress),
          },
        }
      }, {} as UserPositions)

      return userPositions
    }
    return {} as UserPositions
  })


export default createReducer(initialState, (builder) =>
  builder
    // Protocol actions
    .addCase(updateProtocolV3Data, (state, {payload: {protocolData}}) => {
      state.protocol.overview = protocolData
    })
    .addCase(updateProtocolV3ChartData, (state, {payload: {chartData}}) => {
      state.protocol.chartData = chartData
    })
    // Pool actions
    .addCase(updatePoolV3Data, (state, {payload: {pools}}) => {
      pools.forEach((poolData) => {
        state.pools.byAddress[poolData.address] = {
          ...state.pools.byAddress[poolData.address],
          data: poolData,
        }
      })
    })
    // .addCase(fetchAllPoolFeesAsync.pending, (state, {payload: {}}) => {
      // state.poolFees = {
      //   ...state.poolFees,
      //   dataLoaded: false,
      // }
    // })
    .addCase(fetchAllPoolFeesAsync.fulfilled, (state, {payload: {data, pools}}) => {
      Object.keys(data).forEach(date => {
        state.poolFees.byDate[date] = data[date]
      })

      state.poolFees = {
        ...state.poolFees,
        dataLoaded: true,
        pools: pools
      }
    })
    .addCase(resetPoolsFeeData, (state, {}) => {
      state.poolFees = {
        ...state.poolFees,
        dataLoaded: false,
        byDate: {},
        pools: [],
      };
    })
    .addCase(fetchPoolsPublicDataAsync.fulfilled, (state, {payload}) => {
      Object.keys(payload).forEach(poolAddress => {
        // if not existing create enrry
        if (!state.pools.byAddress[poolAddress]) {
          state.pools.byAddress[poolAddress] = {
            data: payload[poolAddress],
            chartData: undefined,
            transactions: undefined,
            userData: undefined,
            userChartData: undefined,
          }
        } else {
          // we update the data
          state.pools.byAddress[poolAddress] = {
            ...state.pools.byAddress[poolAddress],
            data: payload[poolAddress],
          }
        }
      })
    })
    .addCase(updatePoolV3ChartData, (state, {payload: {poolAddress, chartData}}) => {
      state.pools.byAddress[poolAddress] = {...state.pools.byAddress[poolAddress], chartData}
    })
    .addCase(fetchUserPositionsAsync.fulfilled, (state, {payload}) => {
      // if empty then reset all user data
      if (isEmpty(payload)) {
        // only reset for given chainId
        Object.keys(state.pools.byAddress)?.forEach(address => {
          state.pools.byAddress[address] = {
            ...state.pools.byAddress[address],
            userData: undefined
          }
        })
      }

      Object.keys(payload).forEach(poolAddress => {
        if (!state.pools.byAddress[poolAddress]) {
          state.pools.byAddress[poolAddress] = {
            data: payload[poolAddress].data,
            chartData: undefined,
            transactions: undefined,
            userData: undefined,
            userChartData: undefined,
          }
        }
        state.pools.byAddress[poolAddress].userData = payload[poolAddress].userData
      })
      if (!state.userDataLoaded) {
        state.userDataLoaded = true
      }
    })
    .addCase(fetchPoolUserDataAsync.fulfilled, (state, {payload}) => {

      if (isEmpty(payload) || !payload?.poolAddress) {
        return
      }

      if (payload && payload?.poolAddress && !state.pools.byAddress[payload.poolAddress]) {
        state.pools.byAddress[payload.poolAddress] = {
          data: undefined,
          chartData: undefined,
          transactions: undefined,
          userData: undefined,
          userChartData: undefined,
        }
      }
      state.pools.byAddress[payload.poolAddress].userData = payload.userData
    })
    // userData action
    .addCase(updateUserDataLoaded, (state, action) => {
      state.userDataLoaded = action.payload
    })
    .addCase(purgeUserData, (state, action) => {
      Object.keys(state.pools.byAddress)?.forEach(address => {
        state.pools.byAddress[address] = {
          ...state.pools.byAddress[address],
          userData: undefined
        }
      })
    })
)
